import { ConsumerInteractionModel, ConsumerInteractionProgressType } from "../models/consumer/consumer-interaction.model";
import { Subscription, Observable } from "rxjs";

export function getInteractionType(interactions: ConsumerInteractionModel[]): ConsumerInteractionProgressType {


    var interactionsCompleted = 0;
    var interactionsProcessing = 0;

    if (interactions.length == 0) return null;
    for (let i = 0; i < interactions.length; i++) {

        if (interactions[i].requestStatus.toUpperCase() == "INITIALISED"
            || interactions[i].requestStatus.toUpperCase() == "ACTIVE"
            || interactions[i].requestStatus.toUpperCase() == "ACCEPTED"
            || interactions[i].requestStatus.toUpperCase() == "PROCESSING") {
            interactionsProcessing++;    
        }

        if (interactions[i].requestStatus.toUpperCase() == "COMPLETED") {
            interactionsCompleted++;
        }

        if (interactions[i].requestStatus.toUpperCase() == "ERROR" ||
            interactions[i].requestStatus.toUpperCase() == "EXPIRED") {
            return ConsumerInteractionProgressType.Error;
        }
    }

    if (interactionsProcessing == interactions.length ||
        interactionsProcessing > interactionsCompleted) {
        return ConsumerInteractionProgressType.InProgress;
    }

    if (interactionsCompleted == interactions.length) {
        return ConsumerInteractionProgressType.Completed;
    }

    return ConsumerInteractionProgressType.Error;
}
